import React from "react";
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import { CatalogoItem, PagoForm } from "../constants";

type PaymentsCardProps = {
  pagos: PagoForm[];
  medios: CatalogoItem[];
  totalFactura: number;
  onChangePago: (id: number, field: keyof PagoForm, value: string | number | null) => void;
  onAddPago: () => void;
  onRemovePago: (id: number) => void;
};

const renderMedio = (medio: CatalogoItem) =>
  medio.descripcion || medio.codigo || `#${medio.id}`;

const PaymentsCard: React.FC<PaymentsCardProps> = ({
  pagos,
  medios,
  totalFactura,
  onChangePago,
  onAddPago,
  onRemovePago,
}) => {
  const totalPagos = pagos.reduce((acc, pago) => acc + (Number(pago.monto) || 0), 0);
  const pendiente = Number((totalFactura - totalPagos).toFixed(2));

  return (
    <Card className="shadow-sm h-100">
      <CardBody>
        <Row className="mb-3">
          <Col>
            <h5 className="mb-1">Pagos</h5>
            <p className="text-muted mb-0">Distribuí el total por medio de pago.</p>
          </Col>
          <Col className="text-end">
            <Button color="secondary" outline size="sm" onClick={onAddPago}>
              Agregar pago
            </Button>
          </Col>
        </Row>
        {pagos.map((pago) => (
          <Row className="g-2 align-items-end mb-3" key={pago.id}>
            <Col md={4}>
              <Label className="form-label">Medio</Label>
              <Input
                type="select"
                value={pago.medioPagoId ?? ""}
                onChange={(event) =>
                  onChangePago(
                    pago.id,
                    "medioPagoId",
                    event.target.value ? Number(event.target.value) : null,
                  )
                }
              >
                <option value="">Seleccioná</option>
                {medios.map((medio) => (
                  <option key={medio.id} value={medio.id}>
                    {renderMedio(medio)}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="form-label">Monto</Label>
              <Input
                type="number"
                min={0}
                value={pago.monto}
                onChange={(event) =>
                  onChangePago(pago.id, "monto", Number(event.target.value) || 0)
                }
              />
            </Col>
            <Col md={4}>
              <Label className="form-label">Referencia</Label>
              <Input
                value={pago.referencia}
                onChange={(event) => onChangePago(pago.id, "referencia", event.target.value)}
              />
            </Col>
            <Col md={1} className="text-end">
              <Button
                color="link"
                className="text-danger"
                size="sm"
                onClick={() => onRemovePago(pago.id)}
                disabled={pagos.length === 1}
              >
                <i className="bi bi-trash" />
              </Button>
            </Col>
          </Row>
        ))}
        <div className="border-top pt-2 d-flex justify-content-between">
          <span>Total a pagar</span>
          <strong>{totalPagos.toLocaleString("es-PY", { style: "currency", currency: "PYG" })}</strong>
        </div>
        <div className={`d-flex justify-content-between ${pendiente === 0 ? "text-success" : "text-warning"}`}>
          <span>Pendiente</span>
          <strong>
            {pendiente.toLocaleString("es-PY", { style: "currency", currency: "PYG" })}
          </strong>
        </div>
      </CardBody>
    </Card>
  );
};

export default PaymentsCard;
